<template>
  <div class="address">
    <div class="page-header">
      <i class="iconfont icon-back" @click="goBack">&#xe615;</i>
      <div class="page-title">地址管理</div>
      <i class="iconfont"></i>
    </div>
    <div class="" v-if="list && list.length">
      <div class="header">
        <h1>地址簿</h1>
        <div class="add-btn" @click="showDialog">添加地址</div>
      </div>
      <ul>
        <li class="address-tile" v-for="(item, i) in list" :key="i">
          <div class="address-header">
            <div class="address-name"></div>
            <div class="address-isdefault" @click="setDefault(item)">
              <i class="iconfont">{{ item.isDefault ? '&#xedaf;' : '&#xec58;' }}</i>
              {{ item.isDefault ? '默认地址' : '设为默认' }}
            </div>
          </div>
          <div class="address-info">
            <div class="address-fields">
              <div class="address-attr">
                <span class="attr-name">收货人：</span>
                <span class="attr-value">{{ item.username }}（{{ ['-', '先生', '女士'][item.sex] || '-' }}）</span>
              </div>
              <div class="address-attr">
                <span class="attr-name">所在地区：</span>
                <span class="attr-value" v-if="!isTaiwanHKMacau(item.province)">{{ item.province }}{{ item.city }}{{
                  item.county
                }}</span>
              </div>
              <div class="address-attr">
                <span class="attr-name">详细地址：</span>
                <span class="attr-value" v-if="!isTaiwanHKMacau(item.province)">{{ item.detail }}</span>
              </div>
              <div class="address-attr">
                <span class="attr-name">手机：</span>
                <span class="attr-value">{{ item.mobile }}</span>
              </div>
              <div class="address-attr">
                <span class="attr-name">邮政编码：</span>
                <span class="attr-value">{{ item.postcode }}</span>
              </div>
            </div>
            <div class="address-actions">
              <i class="iconfont del-icon" @click="removeItem(item)">&#xe606;</i>
              <i class="iconfont edit-icon" @click="editItem(item)">&#xe618;</i>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-else class="addressbook-empty">
      <h1 class="empty-hits">您的地址簿为空</h1>
      <div class="btns-group">
        <button class="new-address" @click="showDialog">添加地址</button>
      </div>
    </div>
    <!-- address弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogAddress" :before-close="resetForm" :destroy-on-close="true" class="modal" width="600px" center>
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item prop="username" label="收货人" :label-width="formLabelWidth">
          <el-input v-model.trim="form.username" autocomplete="off" placeholder="请输入收货人名称" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item prop="sex" label="称谓" :label-width="formLabelWidth">
          <el-select v-model="form.sex" placeholder="请选择称谓">
            <el-option label="先生" :value="1"></el-option>
            <el-option label="女士" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号码" :label-width="formLabelWidth">
          <el-input v-model.trim="form.mobile" autocomplete="off" placeholder="请输入手机号码" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item prop="regions" label="所在地区" :label-width="formLabelWidth">
          <el-cascader :options="regions" :props="optionProps" v-model="form.regions" :clearable="true" placeholder="请选择所在地区"></el-cascader>
        </el-form-item>
        <el-form-item prop="detail" label="详细地址" :label-width="formLabelWidth">
          <el-input v-model.trim="form.detail" autocomplete="off" placeholder="请输入详细地址" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="postcode" label="邮政编码" :label-width="formLabelWidth">
          <el-input type="number" v-model.trim="form.postcode" autocomplete="off" placeholder="请输入邮政编码(选填)" maxlength="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInfo">确 定</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api';
import types from '@/store/types';
import { captureManualError } from '@/sentry/index'
// import regions from '@/assets/data/districts.json';
import utils from '@/utils';

// eslint-disable-next-line no-misleading-character-class
const regEmoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/ig;

export default {
  data() {
    return {
      // 
      formLabelWidth: "85px",
      dialogTitle: "添加地址",
      list: [],
      // 
      dialogAddress: false,
      form: {
        username: "",
        sex: "",
        mobile: "",
        regions: [],
        detail: "",
        postcode: ""
      },
      rules: {
        username: [{
          required: true, validator(rule, value, callback) {
            if (!value) {
              callback(new Error("请输入姓名"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        sex: [{ required: true, message: "请选择称谓", trigger: "blur" }],
        mobile: [{
          required: true, message: "请输入手机号码",
          validator(fieldRule, value, callback) {
            if (!value) {
              callback(new Error("请输入手机号码"));
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error("请输入正确的手机号码"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        regions: [{
          required: true, message: "请选择所在地区", type: "array",
          validator: (fieldRule, value, callback) => {
            if (value.length != 3) {
              callback(new Error("请选择地址"))
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        detail: [{
          required: true,
          validator(rule, value, callback) {
            if (!value) {
              callback(new Error("请输入详细地址"));
            } else if (regEmoji.test(value)) {
              callback(new Error("详细地址中不能包含Emoji字符"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }]
      },
      regions: [],
      optionProps: {
        value: "name",
        label: "name",
        children: "children"
      }
    };
  },
  created() {
    this.loadSource();
  },
  methods: {
    // isShowOriginalPrice: utils.isShowOriginalPrice,
    isTaiwanHKMacau(text) {
      return utils.isTaiwanHKMacau(text)
    },

    // 加载地址簿
    loadSource() {
      api[types.GET_CITIES]().then((res) => {
        this.regions = res.data
      })
      api[types.ADDRESS_LIST]().then(res => {
        if (res?.data?.list?.length) {
          this.list = this.toSort(res.data.list);
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
        captureManualError(err)
      });
    },
    showDialog() {
      this.dialogAddress = true;
    },
    resetForm(done) {
      this.dialogTitle = "添加地址";
      this.form = { username: "", sex: "", mobile: "", province:"", city: "", county: "", detail: "", postcode: "" };
      done && done();
    },
    closeDialog() {
      this.resetForm();
      this.dialogAddress = false;
    },
    // 保存地址信息
    saveInfo() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let newArgs = Object.assign({}, this.form);
          newArgs.province = newArgs.regions[0];
          newArgs.city = newArgs.regions[1];
          newArgs.county = newArgs.regions[2];
          delete newArgs.regions;
          api[types.SAVE_ADDRESS](newArgs).then(res => {
            if (res?.data?.id) {
              // 修改
              if (newArgs.id) {
                let idx = this.list.findIndex(item => item.id == newArgs.id);
                this.list[idx] = newArgs;
              } else {
                newArgs.id = res.data.id;
                this.list.push(newArgs);
              }
              this.closeDialog();
            } else {
              console.warn(res);
            }
          }).catch(err => {
            console.warn(err);
            captureManualError(err)
          });
        }
      })
    },
    // 编辑
    editItem(address) {
      this.dialogTitle = "编辑地址";
      let newArgs = Object.assign({}, address);
      newArgs.sex && (newArgs.sex = parseInt(newArgs.sex));
      newArgs.regions = utils.isTaiwanHKMacau(newArgs?.province) ? [] : [newArgs.province, newArgs.city, newArgs.county];
      delete newArgs.province;
      delete newArgs.city;
      delete newArgs.county;
      this.form = newArgs;
      this.showDialog();
    },
    // 设为默认
    setDefault(address) {
      if (!address.isDefault) {
        api[types.SET_DEF_ADDRESS]({id: address.id}).then(res => {
          if (res?.code == 1) {
            this.list.forEach(item => {
              if (item.id == address.id) {
                item.isDefault = 1;
              } else {
                item.isDefault = 0;
              }
            });
            this.list = this.toSort(this.list);
          } else {
            console.warn(res);
          }
        }).catch(err => {
          console.warn(err);
          captureManualError(err)
        });
      }
    },
    // 删除
    removeItem(address) {
      this.$confirm("确定要删除该地址信息吗？").then(() => {
        api[types.DEL_ADDRESS]({ id: address.id }).then(res => {
          if (res?.code == 1) {
            let idx = this.list.findIndex(item => item.id == address.id);
            if (idx != -1) this.list.splice(idx, 1);
          } else {
            console.warn(res);
          }
        }).catch(err => {
          console.warn(err);
          captureManualError(err)
        })
      }).catch((error) => { captureManualError(error) })
    },
    toSort(items) {
      return items.sort((a, b) => {
        if (a.isDefault < b.isDefault) {
          return 1;
        } else if (a.isDefault > b.isDefault) {
          return -1;
        } else {
          return 0;
        }
      });
    },
    goBack() {
      this.$router.push({ path: '/account' })
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog { width: 600px; max-width: 100%; }
// ::v-deep .el-form-item__label { text-align: left; }
::v-deep .el-form-item__content { margin-left: 0; width: 70%; }
::v-deep .el-date-editor.el-input, .el-select, .el-cascader { width: 100%; }
.address {
  text-align: left;
  .page-header {
    box-sizing: border-box; width: 100%; height: 40px; margin-bottom: 20px; border-bottom: 1px solid #E7E7E7; position: relative; display: none;
    .icon-back { color: #BCBCBC; line-height: 40px; width: 40px; position: absolute; top: 0; left: 0; cursor: pointer; }
    .page-title { font-size: 13px; color: #333333; line-height: 40px; text-align: center; }
  }
  .header { display: flex; justify-content: space-between; align-items: center; }
  h1 { margin: 0; }
  .add-btn {
    cursor: pointer;
    display: inline-block;
    box-sizing: border-box;
    line-height: 38px;
    padding: 0 30px;
    font-weight: 400;
    font-size: 0.875rem;
    letter-spacing: normal;
    border-radius: 2px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    transition: all 0.3s ease;
    color: #fff;
    background-color: #7f0019;
  }
  ul {
    margin-top: 20px;
    .address-tile {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border: 1px solid #d2d2dd;
      margin-top: 10px;
      font-size: 12px;
      &:first-child {
        margin-top: 0;
      }
      .address-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
        .address-name {
          font-size: 1.625rem;
          font-weight: 700;
        }
        .address-isdefault {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          cursor: pointer;
        }
      }
      .address-info {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .address-fields {
          flex: 1;
          .address-attr {
            line-height: 22px;
            .attr-name {
              display: table-cell;
              width: 60px;
              color: #999;
              text-align: right;
            }
            .attr-value {
              display: table-cell;
              margin-left: 5px;
            }
          }
        }
        .address-actions {
          width: 70px;
          text-align: right;
          .iconfont {
            font-size: 20px;
            margin-left: 20px;
            cursor: pointer;
            &:first-child {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  .addressbook-empty {
    padding: 30px 0; text-align: center;
    .empty-hits {
      font-size: calc(1.5rem * 1.6); font-weight: 400; color: #000; text-align: center; text-transform: none; line-height: calc(2.5rem * 1.6); margin: 0.67em 0;
    }
    .btns-group {
      padding: .3125rem;
      .new-address {
        box-sizing: border-box; display: inline-block; width: calc(20.3125rem * 1.6); padding: 5px; margin: calc(1.3125rem * 1.6) 0;
        font-size: calc(.875rem * 1.6); color: #fff; font-weight: 400; letter-spacing: normal; text-align: center; line-height: calc(1.625rem * 1.6); text-decoration: none; text-transform: uppercase;
        transition: all .3s ease; background-color: #7f0019; border: 1px solid #7f0019; border-radius: 2px; cursor: pointer; 
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .modal {
    margin: 0 auto;
  }
  ::v-deep .el-dialog { width: 100%; }
  .address {
    .page-header { display: block; }
    .header {
      justify-content: flex-end;
      h1 { display: none; }
    }
  }
}
@media only screen and (max-width: 768px) {
  .address .header .add-btn { width: 100%; }
}
</style>